<template>
  <div>
    <a-result status="success" :title="title" :sub-title="sub">
      <template #extra>
        <a-button
          class="desc"
          type="primary"
          :loading="iconLoading"
          @click="enterIconLoading"
        >
          {{ $t("general.button.start-examp") }}
        </a-button>
      </template>
      <div class="desc">
        <a-select
          :placeholder="this.$t('ujian.start-examp.placeholder')"
          style="width: 250px"
          @change="handleChange"
          size="large"
        >
          <a-select-option v-for="item in groupsoal" :key="item.id_group">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
    </a-result>
  </div>
</template>
<script>
export default {
  props: ["groupsoal", "spinning"],
  data() {
    return {
      title: this.$t("ujian.start-examp.title"),
      sub: this.$t("ujian.start-examp.description"),
      loading: false,
      iconLoading: false,
      selectedGroupSoal: "",
    };
  },
  methods: {
    handleChange(value) {
      this.selectedGroupSoal = value //this.groupsoal[this.groupsoal.findIndex(item => item.id_group_soal === value)]    
      this.$store.commit('setSelectedKategori', this.selectedGroupSoal);
    },
    enterLoading() {
      this.loading = true;
    },
    enterIconLoading() {
      if (this.selectedGroupSoal == "") {
          this.$notification['error']({
            message: this.$t('general.message.error.title'),
            description: this.$t('ujian.start-examp.error-kategori-soal'),
            class:"ant-alert-error"            
        });
      } else {
        this.iconLoading = true;
        this.$emit("start-loading", this.iconLoading);
      }
    },
  },
  watch:{
    spinning:function(val){
      this.iconLoading = val;
    }
  }
};
</script>


<style scoped>
.desc {
  margin-top: -30px;
  text-align: center;
}
</style>



 